module.exports = __webpack_public_path__ + "static/mernda-f0ff225a428900f19b328ba87f06646a.jpg";